import React, { useState }  from "react";
import { IoChevronUpSharp, IoChevronDownSharp } from "react-icons/io5";
import { Col } from "react-bootstrap";
import { worktimeline } from "../../content_option";

export const Experience = () => {
    const [jobIndex, setJobIndex] = useState(-1);
    return (
        <>
            <Col lg={{ span: 4, offset: 1}}>
                <h3 className="color_sec py-4 ">Experiences</h3>
            </Col>
            <Col lg="7">
                <table className="table caption-top">
                    <tbody>
                        {worktimeline.map((data, i) => {
                            return (
                                <>
                                    <tr key={i} className="header" onClick={() => jobIndex === i? setJobIndex(-1) : setJobIndex(i)}>
                                        <th scope="row">{data.jobtitle}</th>
                                        <th>{data.where}</th>
                                        <th>{data.date}</th>
                                        <th>{jobIndex != i ? <IoChevronUpSharp /> : <IoChevronDownSharp />}</th>
                                    </tr>
                                    {jobIndex == i && data.description.map((note, index) => {
                                        return <tr key={index}>
                                            <td colSpan="4">- {note}</td>
                                        </tr>
                                    })}
                                </>
                            );
                        })}
                    </tbody>
                </table>
            </Col>
        </>
    )
}